import { z } from "zod";
import { storeOAuthProviders } from "@/features/settings/storeBindingOAuthClient";

export const merchantHomeBindingPartSchema = z.object({
  type: z.literal("data-merchant-store-binding"),
  data: z.object({ schema: z.literal("merchant.store-binding.v1"), card_id: z.string().min(1).max(100), provider: z.enum(storeOAuthProviders), shop_domain: z.string().max(253) }).strict(),
}).strict();
export type MerchantHomeBindingPart = z.infer<typeof merchantHomeBindingPartSchema>;
export function collectMerchantHomeBindingParts(value: unknown): MerchantHomeBindingPart[] {
  if (!Array.isArray(value)) return [];
  const parts = new Map<string, MerchantHomeBindingPart>();
  for (const input of value) { const result = merchantHomeBindingPartSchema.safeParse(input); if (result.success) parts.set(result.data.data.card_id, result.data); }
  return [...parts.values()];
}
export const merchantHomeBindingFlowSchema = z.object({
  card_id: z.string(), operation_id: z.string(),
  state: z.enum(["ready", "waiting", "confirming", "succeeded", "failed", "canceled", "expired"]),
  shops: z.array(z.object({ id: z.string(), name: z.string(), sync_state: z.enum(["healthy", "sync_error", "reauthorization_required"]) }).strict()),
  selected_shop_id: z.string(), continued: z.boolean(), conversation_has_shop: z.boolean(),
}).strict();
